import { FC, useEffect, useState, Dispatch } from "react";
import { StopEventPropagation } from "../../../helper/ui/methods";
import { UserDecisionInterface } from "../../../middleware/interfaces/user/user-decision-interface";

interface userBinaryDecisionDialogProps {
  decision: UserDecisionInterface | null | undefined;
  dispatch: Dispatch<any>;
}

const UserBinaryDecisionDialog: FC<userBinaryDecisionDialogProps> = ({
  decision,
  dispatch,
}) => {
  const [firstOption, setFirstOption] = useState(false);
  const [secondOption, setSecondOption] = useState(false);
  useEffect(() => {
    if (decision) {
      if (firstOption) {
        decision.result = decision.decisionOptions[0];
        setFirstOption(false);
        dispatch({ type: "DECISION", decision: decision });
      }
    }
  }, [firstOption]);

  useEffect(() => {
    if (decision) {
      if (secondOption) {
        decision.result = decision.decisionOptions[1];
        setSecondOption(false);
        dispatch({ type: "DECISION", decision: decision });
      }
    }
  }, [secondOption]);

  // Deleting is the only red thing in the interface, and the decision options
  // are the only place the dialog can learn that is what it is confirming.
  const IsDestructive = () =>
    decision?.decisionOptions[0].startsWith("DELETE_") === true;

  // "DOWNLOAD_PROJECT" -> "Download", so a decision that predates confirmLabel
  // still says what its button does rather than "Yes"
  const ConfirmLabel = () => {
    if (decision?.confirmLabel) {
      return decision.confirmLabel;
    }
    const verb = decision?.decisionOptions[0].split("_")[0] ?? "";
    return verb.charAt(0) + verb.slice(1).toLowerCase();
  };

  return (
    <>
      {(() => {
        if (
          decision !== null &&
          decision !== undefined &&
          decision.decisionOptions.length === 2 &&
          decision.result === ""
        ) {
          return (
            <div className="dialogCover" onClick={StopEventPropagation}>
              <div className="dialog">
                <div className="dialogHeader">
                  <div className="dialogHeading">
                    <h2 className="dialogTitle">{decision.title}</h2>
                  </div>
                  <span
                    className="dialogClose"
                    onClick={() => setSecondOption(true)}
                  >
                    ×
                  </span>
                </div>
                <div className="dialogBody">
                  <h4 className="dialogMessage">{decision.message}</h4>
                </div>
                <div className="dialogButtonWrapper">
                  <input
                    type="button"
                    name="secondDecisionOption"
                    value={"Cancel"}
                    onClick={() => setSecondOption(true)}
                  />
                  <input
                    className={
                      IsDestructive()
                        ? "dialogDestructiveButton"
                        : "dialogPrimaryButton"
                    }
                    type="button"
                    name="firstDecisionOption"
                    value={ConfirmLabel()}
                    onClick={() => setFirstOption(true)}
                  />
                </div>
              </div>
            </div>
          );
        } else {
          return <></>;
        }
      })()}
    </>
  );
};

export default UserBinaryDecisionDialog;
